<script setup lang="ts">
</script>

<template>
	<div class="top-islandRows_subTitle">
		<slot></slot>
	</div>
</template>

<style>
.top-islandRows_subTitle {
	width: 100%;
	font-size: 16px;
	font-weight: bold;
}
</style>
